<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :columns="tableColumns"
      :enableSearch="false"
      :queryParams="queryParams"
      :searchOptions="tableSearchOptions"
      :operationBoxStyle="{padding: '0 0 16px'}"
      :requestPromise="loadData?loadData:loadDataList"
    >
      <a-button slot="operation" type="primary" icon="plus" @click="onAddEvent">新建
      </a-button>
      <template v-slot:status="{text}">
        {{ text === 1 ? '启用' : '禁用' }}
      </template>
      <template v-slot:action="{ record }">
        <a-space>
          <a @click="onEditEvent(record)">编辑</a>
          <a @click="onSwitchStatus(record)">{{ record.status == 1 ? '禁用' : '启用' }}</a>
          <a v-if="showSetting" @click="onSettingEvent(record)">预设设置</a>
        </a-space>
      </template>
    </StandardSearchPageView>
    <SimpleFormEditorDialog
      v-if="showDialog"
      :editConfigList="editConfigList"
      :item="selectItem"
      :rules="rules"
      :title="selectItem&&selectItem.id?'编辑账号':'新增账号'"
      @cancel="showDialog = false"
      @ok="onEditResultEvent"
    />
    <SimpleFormEditorDialog
      v-if="showSettingDialog"
      :editConfigList="editConfigList2"
      :item="selectItem"
      :rules="rules"
      :title="selectItem?'编辑设置':'新增设置'"
      @cancel="showSettingDialog = false"
      @ok="onSettingResultEvent"
      :width="1200"
    >
      <template v-slot:custom="{form}">
        <div class="book-setting-wrap">
          <!-- 1. 累计满XX笔成交 -->
          <div class="form-group">
            <span class="group-desc required-desc">每个酒店的同个入住日，累计满：</span>
            <a-form-model-item
              prop="minOrderCount"
              style="margin-bottom:0;width:160px;display: inline-block"
            >
              <a-input-number
                v-model="form.minOrderCount"
                placeholder="请输入"
                :min="1"
                :step="1"
                style="width:100%"
              />
            </a-form-model-item>
            <span class="after-text">笔，可成交。</span>
          </div>

          <!-- 2. 自动取消提前天数 -->
          <div class="form-group">
            <div class="group-desc">否则，在商品可免费取消截止日期前：</div>
            <a-form-model-item
              prop="freeCancelBeforeDays"
              style="margin-bottom:0;width:160px;display: inline-block"
            >
              <a-input-number
                v-model="form.freeCancelBeforeDays"
                placeholder="请输入"
                :min="0"
                style="width:100%"
              />
            </a-form-model-item>
            <span class="after-text">天，自动取消并原路退款。</span>
          </div>
        </div>
      </template>

    </SimpleFormEditorDialog>
  </div>
</template>

<script>
import SearchMixins from '../../mixins/SearchMixins'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import ValidatorHelper from '@/utils/helper/validatorHelper'
import ZwyMiXins from '@/views/resource/zwy/mixins/ZwyMiXins'

export default {
  name: 'AssociatedAccountComponent',
  mixins: [SearchMixins, ZwyMiXins],
  props: {
    proJoinType: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: () => []
    },
    searchOptions: {
      type: Array,
      default: () => []
    },
    loadData: {
      type: Function,
      default: undefined
    },
    showSetting: {
      type: Boolean,
      default: true
    }
  },
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView
  },
  data() {
    return {
      showDialog: false,
      showSettingDialog: false,
      selectItem: {},
      queryParams: {},
      localSearchOptions: [],
      editConfigList: [
        {
          name: '供应商名称',
          key: 'supplierName',
          placeholder: '请输入供应商名称'
        },
        {
          name: '分销域名',
          key: 'domain',
          placeholder: '请输入分销域名'
        },
        {
          name: '分销商帐号(custId)',
          key: 'custId',
          placeholder: '请输入分销商帐号(custId)'
        },
        {
          name: '分销商验证(apikey)',
          key: 'apikey',
          placeholder: '请输入分销商验证(apikey)'
        }
      ],
      rules: {
        supplierName: [{ required: true, message: '请输入供应商名称', trigger: 'change,blur' }],
        domain: ValidatorHelper.createDomainRule(false, '请输入分销域名', '分销域名码格式有误'),
        custId: [{ required: true, message: '请输入分销商帐号(custId)', trigger: 'change,blur' }],
        apikey: [{ required: true, message: '请输入分销商验证(apikey)', trigger: 'change,blur' }],

        joinTypeList: [{ required: true, message: '请输选择类目', trigger: 'change,blur' }],
        minOrderCount: [{ required: true, message: '请输入订单数', trigger: 'change,blur' }],
        freeCancelBeforeDays: [{ required: true, message: '请输入免费取消截至前天数', trigger: 'change,blur' }]
      },
      editConfigList2: [
        {
          name: '自我游产品类目',
          key: 'joinTypeList',
          placeholder: '请选择类目',
          type: 'checkbox',
          checkOptions: []
        },
        {
          name: ' ',
          key: 'custom',
          slot: true
        }
      ]
    }
  },
  computed: {
    tableColumns () {
      return this.columns && this.columns.length > 0 ? this.columns : this.getColumns()
    },
    tableSearchOptions () {
      return this.searchOptions && this.searchOptions.length > 0 ? this.searchOptions : this.localSearchOptions
    }
  },
  // watch: {
  //   'joinTypeList': function() {
  //     const thirdOption = this.editConfigList2[0]
  //     thirdOption.checkOptions = this.joinTypeList
  //     this.$set(this.editConfigList2, 0, thirdOption)
  //   }
  // },
  mounted() {

  },
  activated() {
  },
  methods: {
    loadDataList(params) {
      const requestParams = {
        ...params.limitDto
      }
      requestParams.proJoinType = this.proJoinType
      return this.getHttpServices().getSourceService().get('zwy/combo/queryAssociateAccount', requestParams)
    },
    getColumns() {
      return [
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          width: '180px'
        },
        {
          title: '分销域名',
          dataIndex: 'domain',
          width: '320px'
        },
        {
          title: '分销商账号',
          dataIndex: 'custId',
          width: '180px'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '100px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '160px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    onSwitchStatus(item) {
      const url = 'zwy/combo/disableAssociateAccount'
      const params = {
        id: item.id,
        status: String(item.status) === '1' ? 0 : 1
      }
      this.getHttpServices().getSourceService().get(url, params)
        .then(res => {
          this.$message.success('操作成功！')
          this.refreshData(false)
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })
    },
    onEditEvent(item) {
      this.selectItem = item
      this.showDialog = true
    },
    onSettingEvent(item) {
      const url = '/zwy/booking/list'
      this.getHttpServices().getSourceService().get(url, { accountId: item.id })
        .then(res => {
          this.selectItem = {
            ...res,
            joinTypeList: String(res.proJoinType).split(',').map(item => Number(item)),
            id: item.id
          }
          this.showSettingDialog = true
        })
        .catch(reason => {
          this.$message.error('操作失败，请重试！')
          console.error(reason)
        })
    },
    onAddEvent() {
      this.selectItem = undefined
      this.showDialog = true
    },
    refreshData() {
      this.$refs.table.refresh()
    },
    onEditResultEvent(params) {
      const url = params.id ? 'zwy/combo/editAssociateAccount' : 'zwy/combo/newAssociateAccount'
      const requestParams = {
        ...params,
        proJoinType: this.proJoinType
      }
      this.getHttpServices().getSourceService().post(url, requestParams)
        .then(res => {
          this.showDialog = false
          this.selectItem = undefined
          this.$message.success('操作成功！')
          const isEdit = !!params.id
          this.refreshData(!isEdit)
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })
    },
    onSettingResultEvent(params) {
      const { id, joinTypeList, minOrderCount, freeCancelBeforeDays } = params
      const url = '/zwy/booking/edit'
      const requestParams = {
        minOrderCount: minOrderCount,
        freeCancelBeforeDays: freeCancelBeforeDays,
        accountId: id,
        proJoinType: joinTypeList.join(',')
      }
      this.getHttpServices().getSourceService().post(url, requestParams)
        .then(res => {
          this.showSettingDialog = false
          this.selectItem = undefined
          this.$message.success('操作成功！')
          const isEdit = !!params.id
          this.refreshData(!isEdit)
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ant-tabs-bar {
  margin: 0 !important;
}

.book-setting-wrap {
  padding: 10px 0;

  .custom-item {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .form-group {
    margin-bottom: 6px;
  }

  .group-desc {
    font-size: 16px;
    color: #333;
    margin-bottom: 12px;
    display: inline-block;
  }

  .required-desc {
    &::before {
      content: "*";
      color: #f5222d;
      margin-right: 4px;
    }
  }

  .check-item {
    font-size: 16px;
  }

  .input-row {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .after-text {
    font-size: 16px;
    color: #333;
  }
}
</style>
